<ng-container>
    <form (ngSubmit)="pesquisar()">
        <div class="parametros-pesquisa-lud" *ngIf="filtroPesquisa.tipoPesquisa === 1">
            <div style="min-width: 180px; flex: 6;">    
                <suite-rfb-select label="Tipo do ato" name="tipoAto" [labels]="cacheDominios.labelsTipoAto" [values]="cacheDominios.tiposAto"  [compareWith]="compareTiposAto"
                    [(ngModel)]="filtroPesquisa.tipoAto" [clearable]="true">
                </suite-rfb-select>
            </div>
            <div class="coluna-parametros-pesquisa-lud" style="min-width: 250px; flex: 4;">
                <div style="min-width: 110px; flex: 2;">
                    <div class="form-group">
                        <label for="numeroAto" class="control-label">Número do ato</label>
                        <input type="text" name="numeroAto" class="form-control" [(ngModel)]="filtroPesquisa.numeroAto" maxlength="20">
                    </div>
                </div>
                <div style="min-width: 140px; flex: 2;">
                    <suite-rfb-date-picker label="Data do ato" name="dataAto" [(ngModel)]="filtroPesquisa.dataAto" 
                        [outsideClick]="true" inputGroupClass="input-group date data-menor">
                    </suite-rfb-date-picker>
                </div>
            </div>
            <div style="min-width: 170px; flex: 2;">
                <div class="form-group">
                    <label for="anoAto" class="control-label">Ano do ato</label>
                    <input type="text" name="anoAto" class="form-control" [(ngModel)]="filtroPesquisa.anoAto">
                </div>
            </div>
        </div>
        <div class="parametros-pesquisa-lud" *ngIf="filtroPesquisa.tipoPesquisa === 1">
            <div style="min-width: 180px; flex: 6;">
                <suite-rfb-select name="orgao" label="Órgãos / unidades"
                        [multiple]="false" [clearable]="true"
                        [labels]="cacheDominios.labelsOrgao" [values]="cacheDominios.orgaos" [compareWith]="compareOrgaos"
                        [(ngModel)]="filtroPesquisa.orgao">
                </suite-rfb-select>
            </div>
            <div class="coluna-parametros-pesquisa-lud" style="min-width: 250px; flex: 4;">
                <div style="min-width: 180px; flex: 3;">
                    <div class="form-group">
                        <label for="identificador" class="control-label">Nome do LUD / Sinônimo</label>
                        <input type="text" name="identificador" class="form-control" [(ngModel)]="filtroPesquisa.identificador">
                    </div>
                </div>
                <div style="min-width: 70px; flex: 1;">
                    <div class="form-group">
                        <label for="idAto" class="control-label">ID do ato</label>
                        <input type="text" name="idAto" class="form-control" [(ngModel)]="filtroPesquisa.idAto">
                    </div>
                </div>
            </div>
            <div style="min-width: 170px; flex: 2;">
                <label class="control-label">&nbsp;</label>
                <div class="form-group" class="botoes-a-direita">
                    <button type="button" title="Limpar" class="btn btn-default btn-sm" (click)="limparFiltroPesquisa()">Limpar</button>
                    <button type="submit" title="Pesquisar" class="btn btn-default btn-sm">Pesquisar</button>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="filtroPesquisa.tipoPesquisa === 2">
            <div class="col-sm-3" style="min-width: 190px;">
                <div class="form-group">
                    <label for="identificador" class="control-label">Nome do LUD / Sinônimo</label>
                    <input type="text" name="identificador" class="form-control" [(ngModel)]="filtroPesquisa.identificador">
                </div>
            </div>
            <div class="col-sm-2" style="min-width: 170px;">
                <label class="control-label">&nbsp;</label>
                <div class="form-group" class="botoes-a-direita">
                    <button type="button" title="Limpar" class="btn btn-default btn-sm" (click)="limparFiltroPesquisa()">Limpar</button>
                    <button type="submit" title="Pesquisar" class="btn btn-default btn-sm">Pesquisar</button>
                </div>
            </div>
            <ng-container *ngIf="exibirMensagemAlerta">
                <div>
                    <label class="control-label">&nbsp;</label>
                    <div>
                        <div class="alerta col-md-7 alert-danger">
                            <div class="alerta-mensagem">
                                <div class="descricao-alerta"> {{ mensagemAlerta }} </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </form>
</ng-container>